import { useUrlParamsValueToString, useTranslation, Metadata } from "@bsm/component";
import { TBankInformation } from "@bsm/graphql";
import { Link } from "react-router-dom";
import { BankInformationInlineMenu } from "./BankInformationInlineMenu";

export const BankListItem = (props: Partial<TBankInformation>) => {

    const urlParams = useUrlParamsValueToString()

    return (
        <div className="flex items-center justify-between w-full pt-2 pb-4 border-default border-b">
            <div className="flex flex-col gap-2">
                <Link to={`${props.id}?${urlParams}`}>
                    {
                        props.bankName &&
                        <h3 className="font-bold text-base sm:text-lg">{props.bankName}</h3>
                    }
                </Link>
                <Metadata
                    label={'Currency'}
                    value={props.currency}
                />
            </div>
            <BankInformationInlineMenu {...props} />
        </div>
    )
}
